import msgpack from "msgpack-lite";

export const pack = (data)=> {
    return msgpack.encode(data)

}
export const unpack = (data)=> {
    return msgpack.decode(new Uint8Array(data))

}
